var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhoItsIcon2(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60.306,
    height: 70.203,
    viewBox: "0 0 60.306 70.203",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_182",
    "data-name": "Rectangle 182",
    width: 60.306,
    height: 70.203,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4540",
    "data-name": "Group 4540",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13667",
    "data-name": "Path 13667",
    d: "M12.521,15.61a15.958,15.958,0,0,0,31.907,0,15.957,15.957,0,0,0-31.907,0m24.817,0a8.714,8.714,0,0,1-8.862,8.5,8.715,8.715,0,0,1-8.865-8.5,8.717,8.717,0,0,1,8.865-8.519,8.717,8.717,0,0,1,8.862,8.519m-28,36.159a12.41,12.41,0,0,1,12.049-9.93H35.567a14.2,14.2,0,0,1,8.158,2.839,3.52,3.52,0,0,0,4.613-5.317,20.827,20.827,0,0,0-12.769-4.613H21.386c-8.864,0-16.66,6.023-19.138,15.249L.473,56.725a10.42,10.42,0,0,0,1.774,9.569,10.726,10.726,0,0,0,8.5,3.907H35.2a3.545,3.545,0,0,0,0-7.091H10.748A2.544,2.544,0,0,1,8.27,61.7,2.866,2.866,0,0,1,7.2,58.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13668",
    "data-name": "Path 13668",
    d: "M47.269,65.588a3.214,3.214,0,0,0,2.478,1.067h.706a4.5,4.5,0,0,0,2.478-1.774L60.021,50.7A3.406,3.406,0,1,0,54,47.518l-4.956,9.913L45.5,53.885a3.518,3.518,0,0,0-4.974,4.975Z",
    fill: "#fff"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhoItsIcon2);
export default __webpack_public_path__ + "static/media/who-its-icon2.2b4bf31bcf3e47546ebfd433463e8b1b.svg";
export { ForwardRef as ReactComponent };